/* 趙雲傳・第 1 章：博望（約 202 年）
 * 劉備的屯在北邊；屯南的大路穿過一段兩側是山、草木深的窄道（李典說的「南道狹窄，草木深」），窄道口兩旁的草叢裡設伏。
 * 夏侯惇、于禁從北邊追來；李典留守在北邊，之後來救。 */
export const TUN = [4000, 1500], CAO = [4000, 450], AMB = [[3550, 2900], [4450, 2900]], VALLEY_Y = 2650, SAFE = [4000, 4500];
export default {
  id: 'zhaoyun_bowang', name: '博望', W: 8000, H: 5000, seed: 2021,
  bases: [TUN, CAO],
  roads: [{ pts: [[4000, 300], CAO, TUN, [3950, 2300], [4050, 3200], [3980, 3900], SAFE, [4000, 4900]], w: 170 }],
  rocks: [[3000, 3200, 650, 320], [5000, 3200, 650, 320], [1500, 1500, 420, 200], [6500, 1300, 420, 200]],
  woods: 0.55,
  sight: 0.8,
  clearings: [[TUN[0], TUN[1], 800], [CAO[0], CAO[1], 500], [4000, 2450, 380], [SAFE[0], SAFE[1], 500]],
  grass: AMB.map(([x, y]) => [x, y, 210, 110]),
  tents: [{ x: TUN[0], y: TUN[1], n: 7, r: 380, chief: true, col: '#3e7b50', flag: '劉' }],
};
